import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";

import { Button } from "@/components/ui/button";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

import type { PaginationMeta } from "@/interfaces/blockchainNetwork";

interface Props {
  meta: PaginationMeta;

  onPageChange: (page: number) => void;

  onLimitChange: (limit: number) => void;
}

const PAGE_SIZES = [10, 20, 50, 100];

const BlockchainNetworkPagination = ({
  meta,
  onPageChange,
  onLimitChange,
}: Props) => {
  return (
    <div className="mt-6 flex flex-col gap-4 rounded-xl border bg-card p-4 lg:flex-row lg:items-center lg:justify-between">
      <div className="text-sm text-muted-foreground">
        Showing page <strong>{meta.page}</strong> of{" "}
        <strong>{meta.totalPages}</strong>
        {" • "}
        <strong>{meta.total}</strong> total blockchain networks
      </div>

      <div className="flex items-center gap-3">
        <Select
          value={String(meta.limit)}
          onValueChange={(value) => onLimitChange(Number(value))}
        >
          <SelectTrigger className="w-28">
            <SelectValue />
          </SelectTrigger>

          <SelectContent>
            {PAGE_SIZES.map((size) => (
              <SelectItem key={size} value={String(size)}>
                {size} / page
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Button
          variant="outline"
          size="icon"
          disabled={meta.page === 1}
          onClick={() => onPageChange(1)}
        >
          <ChevronsLeft className="h-4 w-4" />
        </Button>

        <Button
          variant="outline"
          size="icon"
          disabled={meta.page === 1}
          onClick={() => onPageChange(meta.page - 1)}
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>

        <Button
          variant="outline"
          size="icon"
          disabled={meta.page >= meta.totalPages}
          onClick={() => onPageChange(meta.page + 1)}
        >
          <ChevronRight className="h-4 w-4" />
        </Button>

        <Button
          variant="outline"
          size="icon"
          disabled={meta.page >= meta.totalPages}
          onClick={() => onPageChange(meta.totalPages)}
        >
          <ChevronsRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default BlockchainNetworkPagination;
